module.exports = __webpack_public_path__ + "img/blue-logos.ca345f9.webp";